import { useEffect } from "react";
import { useTheme } from './context/ThemeContext'; // Only useTheme here
import { Header } from "./views/Header";

const ThemedComponent = () => {
  const { colors, toggleTheme } = useTheme();
  
  return (
    <div style={{ background: colors.background, color: colors.text }}>
      Hello Theme
      <button onClick={toggleTheme}>Toggle Theme</button>
    </div>
  );
};

export default function App() {
  useEffect(() => {
    const preventGesture = (e) => {
      e.preventDefault();
    };

    document.addEventListener("gesturestart", preventGesture);
    document.addEventListener("gesturechange", preventGesture);
    document.addEventListener("gestureend", preventGesture);

    return () => {
      document.removeEventListener("gesturestart", preventGesture);
      document.removeEventListener("gesturechange", preventGesture);
      document.removeEventListener("gestureend", preventGesture);
    };
  }, []);

  return (
    <>
      <Header /> 
      <ThemedComponent /> 
    </>
  );
}
